<template>
  <footer class="dj-footer">
    <div class="footer-bottom t-a-c dj-container">
      <Row>
        <i-col>
          <span>{{footer.list[0].copyright}}</span>
          <span>{{footer.list[0].icp}}</span>
        </i-col>
       <!-- <i-col>
          <span>创客/STEAM教育纠纷和解员：{{ footer.list[0].ipman }} </span>
          <span> 电话：{{ footer.list[0].ipman_phone }}</span>
          |
          <span>
            <img style="width: 1rem;height: 1rem;vertical-align: middle; margin-bottom: 3px;" src="~@/assets/01.png" alt="">
            {{ footer.list[0].company_place }}
          </span>
          <span>投诉举报电话：{{ footer.list[0].fbi_phone }}</span>
        </i-col>
        -->
      </Row>
    </div>
  </footer>
</template>

<script>
import { makeSgin } from '@/utils';
export default {
  name: 'djFooter',
  data() {
    return {
      footer: {
        list: [{}]
      }
    }
  },
  created() {
    this.getHomeWenAn()
  },
  methods: {
    getHomeWenAn() {
      this._r.get('open/api/homePage?sign=' + makeSgin()).then(res => {
        res.data.forEach(i => {
          if (i.paramKey === 'HOME_PAGE_9') {
            this.footer = {
              ...i,
              list: JSON.parse(i.paramValue)
            }
          }
        })
      })
    }
  }
}
</script>

<style lang="scss">
.dj-footer {
  background-color: #ffffff;
  color: var(--main-font-color);
}
</style>